import { useLocale } from "../i18n";
import { billingPaymentMethodLabel, type BillingPaymentMethodReference } from "./billingPaymentMethod";

export function PaymentMethodEvidence({ value, attempted = false }: { value: BillingPaymentMethodReference; attempted?: boolean }) {
  const { w } = useLocale();
  return <div className="billing-method">
    <p className="billing-method-label">{attempted ? w("طريقة الدفع في المحاولة: ", "Attempted payment method: ") : w("طريقة الدفع: ", "Payment method: ")}<bdi>{billingPaymentMethodLabel(value, w)}</bdi></p>
    {value.paymentMethodId && <details className="billing-method-reference"><summary>{w("مرجع طريقة الدفع", "Payment method reference")}</summary><dl>
      <div><dt>{w("المعرّف", "ID")}</dt><dd><bdi dir="ltr">{value.paymentMethodId}</bdi></dd></div>
      <div><dt>{w("النوع", "Type")}</dt><dd><bdi dir="ltr">{value.paymentMethodTypeId}</bdi></dd></div>
      <div><dt>{w("آلية التسجيل", "Recording kind")}</dt><dd>{value.paymentMethodKind === "MANUAL" ? w("يدوية", "Manual") : w("مرمّزة", "Tokenized")}</dd></div>
    </dl></details>}
  </div>;
}
